import { createRootRoute, Outlet } from "@tanstack/react-router";
import { DevTools } from "@/components/common/DevTools";
import { NotFound } from "@/components/error/NotFound";

const RootComponent = () => {
  return (
    <>
      <Outlet />
      <DevTools />
    </>
  );
};

export const Route = createRootRoute({
  component: RootComponent,
  notFoundComponent: NotFound,
});
